/**
 * Node identifiers for integrators and end-to-end tests.
 *
 * The web widget tags every meaningful node with `data-ringg="..."` and treats
 * those names as a contract — integrators select on them, so renaming one is a
 * breaking change. RN has no attribute namespace, but it has `testID`, which
 * surfaces to the same audiences (Detox, Maestro, Appium, the native view
 * hierarchy).
 *
 * So the mapping is mechanical and total: `data-ringg="header-title"` becomes
 * `testID="ringg-header-title"`. The prefix keeps widget nodes from colliding
 * with the host app's own testIDs, and the suffix stays byte-identical to web
 * so one selector list documents both platforms.
 */

/** `"header-title"` → `"ringg-header-title"`. */
export const ringgId = (name: string): string => `ringg-${name}`;
